// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M5.4 1.8L10.6 1.8C11.29 1.8 11.85 2.36 11.85 3.05C11.85 3.74 11.29 4.3 10.6 4.3L7.7 4.3M5.21 1.81C5.27 1.8 5.34 1.8 5.4 1.8',
  'M5.23 8.63L3.77 9.75C3.39 10.04 3.2 10.48 3.2 10.96C3.2 11.31 3.49 11.6 3.85 11.6L8.2 11.6M10.12 6.72L10.35 4.3',
  'M8 11.6L8 14.4',
  'M2 2L14 14',
];
